export default __webpack_public_path__ + "static/media/preview_print_White.932b8bc1.svg";